// @ts-nocheck
import * as actions from '../../action-types';
import axios from 'axios';
import utils from '@/app/utils/utils';

export default {
  [actions.UNSUBSCRIBE]: (_, data) => {
    return axios
      .delete('/api/unSubscribe', { data: { id: data.id } })
      .then((result) => {
        return Promise.resolve(result.data);
      })
      .catch((error) => Promise.reject({ code: utils.getErrorCode(error) }));
  },
};
